var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"my-5",attrs:{"cols":"12"}},[_c('h2',{staticClass:"default"},[_vm._v("Solicitação de suporte")])])],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"8","offset-lg":"2"}},[_c('formSuporte',{attrs:{"formData":this.$route.query}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }